import { useState, useEffect, useRef } from "react";
import { Dropdown, Button, Checkbox } from "antd";
import { DownOutlined } from "@ant-design/icons";

const months = [
  { label: "Oct 2025", value: "2025-10" },
  { label: "Nov 2025", value: "2025-11" },
  { label: "Dec 2025", value: "2025-12" },
  { label: "Jan 2026", value: "2026-01" },
  { label: "Feb 2026", value: "2026-02" },
  { label: "Mar 2026", value: "2026-03" },
  { label: "Apr 2026", value: "2026-04" },
  { label: "May 2026", value: "2026-05" },
  { label: "Jun 2026", value: "2026-06" },
  { label: "Jul 2026", value: "2026-07" },
  { label: "Aug 2026", value: "2026-08" },
  { label: "Sep 2026", value: "2026-09" }
];

function getCurrentMonthValue() {
  const now = new Date();
  const month = now.toLocaleString('default', { month: 'short' });
  const year = now.getFullYear();
  const label = `${month} ${year}`;
  const found = months.find(m => m.label === label);
  return found ? found.value : months[0].value;
}

// Build range object for display
function getDisplayRange(selectedMonths) {
  if (!selectedMonths.length) return null;
  const start = selectedMonths[0];
  const end = selectedMonths[selectedMonths.length - 1];
  const startMonth = months.find(m => m.value === start)?.label;
  const endMonth = months.find(m => m.value === end)?.label;
  return {
    startDay: 1,
    endDay: 31,
    startMonth: startMonth ? startMonth.split(' ')[0] : "",
    startYear: startMonth ? startMonth.split(' ')[1] : "",
    endMonth: endMonth ? endMonth.split(' ')[0] : "",
    endYear: endMonth ? endMonth.split(' ')[1] : "",
    weekday: "Sunday" // Example static, can be dynamic
  };
}

export default function TravelMonthDropdown() {
  const [selected, setSelected] = useState([getCurrentMonthValue()]);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState([getCurrentMonthValue()]);
  const displayRange = getDisplayRange(confirmed);

  const menuContent = (
    <div className="bg-white rounded-md shadow-lg p-6 w-[400px]">
      <div className="text-center font-semibold mb-6 text-lg">
        When do you want to travel?
      </div>
      <div className="grid grid-cols-3 gap-3">
        {months.map(month => (
          <div
            key={month.value}
            className={`border rounded-lg px-2 py-4 text-center cursor-pointer transition
              ${selected.includes(month.value)
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 bg-white'}
            `}
            onClick={() => {
              setSelected(current =>
                current.includes(month.value)
                  ? current.filter(v => v !== month.value)
                  : [...current, month.value]);
            }}
          >
            <Checkbox checked={selected.includes(month.value)}>
              <div className="text-base">{month.label.split(' ')[0]}</div>
              <div className="text-xs text-gray-400">{month.label.split(' ')[1]}</div>
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="flex justify-end mt-6">
        <Button
          type="primary"
          className="bg-blue-500 hover:bg-blue-600"
          onClick={() => {
            setConfirmed([...selected].sort());
            setOpen(false);
          }}
        >
          APPLY
        </Button>
      </div>
    </div>
  );

  // The summary display acts as the trigger
  return (
    <Dropdown
      dropdownRender={() => menuContent}
      trigger={["click"]}
      placement="bottomLeft"
      open={open}
      onOpenChange={setOpen}
    >
      <div
        className="cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <div className=" mb-2 text-sm font-medium">
          Travel Month <DownOutlined className="ml-3" />
        </div>
        <div className="flex items-baseline mb-1">
          <span className="text-2xl font-bold">{displayRange?.startDay}</span>
          <span className="ml-2 text-xl font-medium">
            {displayRange?.startMonth}' {displayRange?.startYear} - 
          </span>
          <span className="text-2xl font-bold ml-2">{displayRange?.endDay}</span>
          <span className="ml-2 text-xl font-medium">
            {displayRange?.endMonth}' {displayRange?.endYear}
          </span>
          
        </div>
        <div className="mt-2 text-gray-700 font-semibold text-base">
          {displayRange?.weekday}
        </div>
      </div>
    </Dropdown>
  );
}
